export const commonInsurances = ['Medicare', 'Medicaid']
export const MINIMUM_INSURANCE_CARD_COUNT = 20
export const MAXIMUM_INSURANCE_CARDS_TO_DISPLAY = 14
